import { render } from "./ChangeAddrView.vue?vue&type=template&id=2f5cf0c6"
import script from "./ChangeAddrView.vue?vue&type=script&lang=js"
export * from "./ChangeAddrView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__